const config = {
  //  backendUrl: 'https://api.grieversandfriends.com',
  //  testBackendUrl: 'https://sandbox.api.grieversandfriends.com',
   backendUrl: window.location.pathname.split('/')[1] === 'test' ? 'https://sandbox.api.grieversandfriends.com' : 'https://api.grieversandfriends.com',
  };

  
  export default config;